<template>
  <div>
    <b-card
      title="Araç Değerleme"
    >
      <b-alert
        variant="secondary"
        show
        class="text-center"
      >
        <div class="alert-body">
          Araç bilgilerini kontrol edip araç değerleme işlemini başlatın.
        </div>
      </b-alert>
      <template v-if="loading">
        <b-alert
          show
          class="text-center text-info"
        >
          <div class="alert-body">
            <b-spinner />
            <div>
              Fiyat hesaplanıyor...
            </div>
          </div>
        </b-alert>
      </template>
      <template v-else>
        <div
          v-if="requestResult.result"
          class="text-center bg-light p-2 border rounded mb-1"
        >
          <div class="text-primary font-weight-bold font-medium-2">
            Hesaplanmış Takas Bedeli
          </div>
          <div class="font-medium-4 font-weight-bolder">
            {{ requestResult.valuation | toCurrency }} TL
          </div>
          <div class="text-muted text-italic">
            {{ requestResult.message }}
          </div>
        </div>
        <b-button
          variant="info"
          block
          @click="getValuation"
        >
          <FeatherIcon icon="CheckIcon" />
          Takas Bedeli Hesapla
        </b-button>
      </template>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BButton, BAlert, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'IndicataCard',
  components: {
    BCard,
    BButton,
    BAlert,
    BSpinner,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    requestResult() {
      return this.$store.getters['indicata/requestResult']
    },
  },
  methods: {
    getValuation() {
      this.loading = true
      this.$store.dispatch('indicata/getValuation', this.$route.params.id)
        .then(response => {
          if (response) {
            this.loading = false
          }
        })
    },
  },
}
</script>
